export const OKR_ELEMENT_MODAL_FOOTER_CONFIRM_BUTTON_TEST_ID = 'confirm-button'
export const OKR_ELEMENT_MODAL_FOOTER_CANCEL_BUTTON_TEST_ID = 'cancel-button'
export const OKR_ELEMENT_MODAL_FOOTER_CHECKBOX_TEST_ID = 'footer-actions-checkbox'

export const CONFIRM_INTERVAL_CHANGE_MODAL_TEST_ID = 'confirm-interval-change-modal'
